module.exports = __webpack_public_path__ + "img/foot_o.09f7a906.svg";